export enum RequestsActionTypes {
  GET_LIST_REQUESTS_SUCCESS = "REQUESTS_GET_LIST_SUCCESS",
  GET_LIST_REQUESTS_ERROR = "REQUESTS_GET_LIST_ERROR",
  GET_LIST_REQUESTS = "REQUESTS_GET_LIST",
  CREATE_REQUEST = "CREATE_REQUEST",
  CREATE_REQUEST_SUCCESS = "CREATE_REQUEST_SUCCESS",
  CREATE_REQUEST_ERROR = "CREATE_REQUEST_ERROR",
  GET_REQUEST = "GET_REQUEST",
  GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS",
  GET_REQUEST_ERROR = "GET_REQUEST_ERROR",
  UPDATE_REQUEST = "UPDATE_REQUEST",
  UPDATE_REQUEST_SUCCESS = "UPDATE_REQUEST_SUCCESS",
  UPDATE_REQUEST_ERROR = "UPDATE_REQUEST_ERROR",
  UPDATE_STATUS_REQUEST = "UPDATE_STATUS_REQUEST",
  UPDATE_STATUS_REQUEST_SUCCESS = "UPDATE_STATUS_REQUEST_SUCCESS",
  UPDATE_STATUS_REQUEST_ERROR = "UPDATE_STATUS_REQUEST_ERROR",
  DELETE_REQUEST = "DELETE_REQUEST",
  DELETE_REQUEST_SUCCESS = "DELETE_REQUEST_SUCCESS",
  DELETE_REQUEST_ERROR = "DELETE_REQUEST_ERROR",
  ASSIGN_AGENTS = "REQUEST_ASSIGN_AGENTS",
  ASSIGN_AGENTS_SUCCESS = "REQUEST_ASSIGN_AGENTS_SUCCESS",
  ASSIGN_AGENTS_ERROR = "REQUEST_ASSIGN_AGENTS_ERROR",
  SUBMIT_QUOTE = "REQUEST_SUBMIT_QUOTE",
  SUBMIT_QUOTE_SUCCESS = "REQUEST_SUBMIT_QUOTE_SUCCESS",
  SUBMIT_QUOTE_ERROR = "REQUEST_SUBMIT_QUOTE_ERROR",
  APPROVE_QUOTE = "REQUEST_APPROVE_QUOTE",
  APPROVE_QUOTE_SUCCESS = "REQUEST_APPROVE_QUOTE_SUCCESS",
  APPROVE_QUOTE_ERROR = "REQUEST_APPROVE_QUOTE_ERROR",
}
